const THRESHOLD = 70;
const MAX_PULL = 120;
const SPINNER_SVG =
    '<svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle></svg>';

function isStandalone(): boolean {
    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        !!(window.navigator as Navigator & { standalone?: boolean }).standalone
    );
}

function getScrollTop(): number {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function dampen(delta: number): number {
    if (delta <= 0) {
        return 0;
    }
    return Math.min(MAX_PULL, delta * 0.5);
}

function createIndicator(): HTMLElement {
    const el = document.createElement('div');
    el.className = 'ptr-indicator';
    el.innerHTML = `<div class="ptr-spinner">${SPINNER_SVG}</div>`;
    document.body.appendChild(el);
    return el;
}

function setPull(indicator: HTMLElement, pull: number, spinning = false): void {
    indicator.style.transform = `translate3d(0, ${pull}px, 0)`;
    indicator.style.opacity = pull > 0 ? String(Math.min(1, pull / THRESHOLD)) : '0';
    indicator.classList.toggle('is-ready', pull >= THRESHOLD && !spinning);
    indicator.classList.toggle('is-spinning', spinning);
}

function resetIndicator(indicator: HTMLElement): void {
    indicator.classList.add('is-resetting');
    setPull(indicator, 0);
    window.setTimeout(() => {
        indicator.classList.remove('is-resetting');
    }, 300);
}

function bindTouchHandlers(indicator: HTMLElement): void {
    let startY = 0;
    let armed = false;
    let pulling = false;
    let currentPull = 0;

    const onTouchStart = (event: TouchEvent) => {
        if (getScrollTop() > 0 || event.touches.length !== 1) {
            armed = false;
            return;
        }
        startY = event.touches[0].clientY;
        armed = true;
        pulling = false;
        currentPull = 0;
    };

    const onTouchMove = (event: TouchEvent) => {
        if (!armed || event.touches.length !== 1) {
            return;
        }
        const delta = event.touches[0].clientY - startY;
        if (delta <= 0) {
            if (pulling) {
                pulling = false;
                currentPull = 0;
                setPull(indicator, 0);
            }
            return;
        }
        if (getScrollTop() > 0) {
            armed = false;
            return;
        }
        pulling = true;
        currentPull = dampen(delta);
        setPull(indicator, currentPull);
        event.preventDefault();
    };

    const onTouchEnd = () => {
        if (!armed) {
            return;
        }
        armed = false;
        if (!pulling) {
            return;
        }
        pulling = false;
        if (currentPull >= THRESHOLD) {
            setPull(indicator, THRESHOLD, true);
            window.setTimeout(() => {
                window.location.reload();
            }, 600);
            return;
        }
        resetIndicator(indicator);
        currentPull = 0;
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onTouchEnd, { passive: true });
}

export function pullToRefresh(): void {
    if (!isStandalone()) {
        return;
    }
    const indicator = createIndicator();
    bindTouchHandlers(indicator);
}
